const vendrediSuiteContent = `
Pendant que vous étiez perdu{% if isWoman %}e{% endif %} dans vos pensées, votre manager vous explique le problème.
Il faut terminer la production du projet pour mardi soir. Il y a 4 jours de travail à reprendre.
Si vous travaillez ce week-end, ça peut passer. Il s’agit d’un projet stratégique, vous comprenez…
`

const vendrediSuiteChoices = ['transparence', 'recup', 'ardeche']

export default [
  {
    id: 'vendredi',
    content: `
    Vendredi soir, 18h45. Vous rentrez chez vous dans 5 minutes.

    Votre manager vous appelle : « Désolé de te déranger, on a un truc à te demander avec Yoann…
    C’est un peu délicat. » Quel est votre ressenti ?
    `,
    choices: ['vendredisuite1', 'vendredisuite2', 'vendredisuite3'],
  },
  {
    id: 'vendredisuite1',
    optionText: `Ça sent le roussi, je n’aime pas ça…`,
    content: vendrediSuiteContent,
    choices: vendrediSuiteChoices,
  },
  {
    id: 'vendredisuite2',
    optionText: `Formidable, je me sens utile comme jamais !`,
    content: vendrediSuiteContent,
    choices: vendrediSuiteChoices,
  },
  {
    id: 'vendredisuite3',
    optionText: `Qui a bien pu encore rendre son projet en retard...`,
    content: vendrediSuiteContent,
    choices: vendrediSuiteChoices,
  },
  {
    id: 'transparence',
    optionText: `Je pense que si l’on procède ainsi, on ne peut pas garantir la qualité des livrables.
    Je préfère qu’on soit transparent auprès du client, et qu’on lui propose une livraison décalée.
    En contrepartie, je m’engage sur la qualité, comme ça le client formulera moins de retours et sera
    plus satisfait du travail fourni.`,
    content: `
    Votre réponse est précise, vous proposez une solution alternative sans surcharge de travail et
    conservez votre sérénité pour le week-end. Vos supérieurs ont ainsi de quoi faire patienter
    le commanditaire...

    *FIN*

    [Recommencer](@start)
    `,
  },
  {
    id: 'recup',
    optionText: `Oui, je comprends tout à fait. Envoyez-moi un brief et les documents d’ici demain matin.`,
    content: `
    Vous acceptez à contrecœur la mission, sans véritablement exprimer votre frustration. Attention à ce
    que cela reste exceptionnel afin de conserver votre équilibre vie privée-vie professionnelle !

    *FIN*

    [Recommencer](@start)
    `,
  },
  {
    id: 'ardeche',
    optionText: `Ça tombe mal, je pars en week-end en Ardèche… On improvisera une solution, à lundi !`,
    content: `
    On a tous envie de formuler cette réponse un peu désinvolte, n’est-ce pas ? Or, avec une telle réplique,
    c’est le début des ennuis. Même si vous pouvez considérer que votre manager franchit une ligne jaune,
    il a fait l’effort de mettre les formes dans sa demande. Vous auriez pu commencer votre réponse de la même
    façon, et essayer de voir comment trouver une solution ensemble.

    *FIN*

    [Recommencer](@start)
    `,
  },
]
